export const darkTheme = {
    chart: {
        backgroundColor: 'transparent',
        style: {
            fontFamily: 'Arial, sans-serif'
        },
        plotBorderColor: '#606063'
    },
    title: {
        style: {
            color: '#E0E0E3',
            fontSize: '20px'
        }
    },
    xAxis: {
        gridLineColor: '#505053',
        labels: {
            style: {
                color: '#E0E0E3'
            }
        },
        lineColor: '#505053',
        minorGridLineColor: '#404043',
        tickColor: '#505053',
        title: {
            style: {
                color: '#A0A0A3'
            }
        }
    },
    yAxis: {
        gridLineColor: '#505053',
        labels: {
            style: {
                color: '#E0E0E3'
            }
        },
        lineColor: '#505053',
        minorGridLineColor: '#404043',
        tickColor: '#505053',
        tickWidth: 1,
        title: {
            style: {
                color: '#A0A0A3'
            }
        }
    },
    tooltip: {
        backgroundColor: 'rgba(18, 18, 18, 0.85)', // Slightly transparent dark background
        style: {
            color: '#F0F0F0'
        }
    },
    legend: {
        backgroundColor: 'transparent',
        itemStyle: {
            color: '#E0E0E3'
        },
        itemHoverStyle: {
            color: '#FFF'
        },
        itemHiddenStyle: {
            color: '#606063'
        },
        title: {
            style: {
                color: '#C0C0C0'
            }
        }
    },
    credits: {
        style: {
            color: '#666'
        }
    },
    labels: {
        style: {
            color: '#707073'
        }
    },
    drilldown: {
        activeAxisLabelStyle: {
            color: '#F0F0F3'
        },
        activeDataLabelStyle: {
            color: '#F0F0F3'
        }
    },
    navigation: {
        buttonOptions: {
            // symbolStroke: '#DDDDDD',
            theme: {
                fill: 'transparent' // Transparent background for buttons
            }
        }
    }
    // navigator: {
    //     handles: {
    //         backgroundColor: '#666',
    //         borderColor: '#AAA'
    //     },
    //     outlineColor: '#CCC',
    //     maskFill: 'rgba(255,255,255,0.1)',
    //     series: {
    //         color: '#7798BF',
    //         lineColor: '#A6C7ED'
    //     },
    //     xAxis: {
    //         gridLineColor: '#505053'
    //     }
    // },
    // scrollbar: {
    //     barBackgroundColor: '#808083',
    //     barBorderColor: '#808083',
    //     buttonArrowColor: '#CCC',
    //     buttonBackgroundColor: '#606063',
    //     buttonBorderColor: '#606063',
    //     rifleColor: '#FFF',
    //     trackBackgroundColor: 'transparent', // Transparent background for scrollbar track
    //     trackBorderColor: 'transparent'
    // }
};

export const lightTheme = {
    chart: {
        backgroundColor: 'transparent',
        style: {
            fontFamily: 'Arial, sans-serif'
        },
        plotBorderColor: '#606063'
    },
    title: {
        style: {
            color: '#333333',
            fontSize: '20px'
        }
    },
    xAxis: {
        gridLineColor: '#E6E6E6',
        labels: {
            style: {
                color: '#333333'
            }
        },
        lineColor: '#E6E6E6',
        minorGridLineColor: '#F2F2F2',
        tickColor: '#E6E6E6',
        title: {
            style: {
                color: '#666666'
            }
        }
    },
    yAxis: {
        gridLineColor: '#E6E6E6',
        labels: {
            style: {
                color: '#333333'
            }
        },
        lineColor: '#E6E6E6',
        minorGridLineColor: '#F2F2F2',
        tickColor: '#E6E6E6',
        tickWidth: 1,
        title: {
            style: {
                color: '#666666'
            }
        }
    },
    tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.85)', // Slightly transparent light background
        style: {
            color: '#333333'
        }
    },
    legend: {
        backgroundColor: 'transparent',
        itemStyle: {
            color: '#333333'
        },
        itemHoverStyle: {
            color: '#000'
        },
        itemHiddenStyle: {
            color: '#CCC'
        },
        title: {
            style: {
                color: '#333333'
            }
        }
    },
    credits: {
        style: {
            color: '#666'
        }
    },
    labels: {
        style: {
            color: '#333333'
        }
    },
    drilldown: {
        activeAxisLabelStyle: {
            color: '#333333'
        },
        activeDataLabelStyle: {
            color: '#333333'
        }
    },
    navigation: {
        buttonOptions: {
            symbolStroke: '#CCCCCC',
            theme: {
                fill: 'transparent' // Transparent background for buttons
            }
        }
    },
    rangeSelector: {
        buttonTheme: {
            fill: 'transparent',
            stroke: '#CCCCCC',
            style: {
                color: '#333'
            },
            states: {
                hover: {
                    fill: '#CCCCCC',
                    stroke: '#AAAAAA',
                    style: {
                        color: 'black'
                    }
                },
                select: {
                    fill: '#000003',
                    stroke: '#AAAAAA',
                    style: {
                        color: 'black'
                    }
                }
            }
        },
        inputBoxBorderColor: '#CCCCCC',
        inputStyle: {
            backgroundColor: 'transparent',
            color: 'black'
        },
        labelStyle: {
            color: 'black'
        }
    },
    // navigator: {
    //     handles: {
    //         backgroundColor: '#E6E6E6',
    //         borderColor: '#AAAAAA'
    //     },
    //     outlineColor: '#CCCCCC',
    //     maskFill: 'rgba(255,255,255,0.1)',
    //     series: {
    //         color: '#7798BF',
    //         lineColor: '#A6C7ED'
    //     },
    //     xAxis: {
    //         gridLineColor: '#E6E6E6'
    //     }
    // },
    // scrollbar: {
    //     barBackgroundColor: '#E6E6E6',
    //     barBorderColor: '#E6E6E6',
    //     buttonArrowColor: '#666',
    //     buttonBackgroundColor: '#CCCCCC',
    //     buttonBorderColor: '#CCCCCC',
    //     rifleColor: '#333',
    //     trackBackgroundColor: 'transparent', // Transparent background for scrollbar track
    //     trackBorderColor: 'transparent'
    // }
};